import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigation = [
    {
      name: 'AI Agents',
      hasDropdown: true,
      items: ['Voice Agent', 'Customer Service', 'Sales Agent', 'Booking Agent', 'Lead Qualification']
    },
    {
      name: 'Platform',
      hasDropdown: true,
      items: ['Agent Builder', 'Analytics', 'Integrations', 'Security']
    },
    { name: 'Solutions', hasDropdown: false },
    { name: 'Resources', hasDropdown: false },
    { name: 'Company', hasDropdown: false }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/80 backdrop-blur-lg'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <img 
              src="https://customer-assets.emergentagent.com/job_ff87029c-4a94-4b3a-94b0-df833d291323/artifacts/zao927uo_BVSL%20LOGO.png" 
              alt="Blue Vantage" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navigation.map((item, idx) => (
              <div key={idx} className="relative group">
                <button className="flex items-center gap-1 text-gray-700 hover:text-blue-600 font-medium transition-colors">
                  {item.name}
                  {item.hasDropdown && <ChevronDown className="w-4 h-4" />}
                </button>
                {item.hasDropdown && (
                  <div className="absolute top-full left-0 mt-2 w-56 bg-white rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform group-hover:translate-y-0 translate-y-2">
                    <div className="py-3">
                      {item.items.map((subItem, subIdx) => (
                        <a
                          key={subIdx}
                          href="#"
                          className="block px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors"
                        >
                          {subItem}
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center gap-4">
            <Button variant="ghost" className="text-gray-700 hover:text-blue-600">
              Sign In
            </Button>
            <Button className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white rounded-full px-6 transition-all duration-300 hover:shadow-lg hover:scale-105">
              Get A Demo
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-gray-700 hover:text-blue-600 transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-xl">
          <div className="px-6 py-6 space-y-4">
            {navigation.map((item, idx) => (
              <div key={idx}>
                <button className="w-full text-left text-gray-700 hover:text-blue-600 font-medium py-2 transition-colors">
                  {item.name}
                </button>
                {item.hasDropdown && (
                  <div className="pl-4 space-y-2 mt-2">
                    {item.items.map((subItem, subIdx) => (
                      <a
                        key={subIdx}
                        href="#"
                        className="block text-gray-600 hover:text-blue-600 py-2 transition-colors"
                      >
                        {subItem}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <div className="pt-4 space-y-3">
              <Button variant="outline" className="w-full">
                Sign In
              </Button>
              <Button className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white">
                Get A Demo
              </Button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;